var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmexCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.977,
    height: 60.15,
    viewBox: "0 0 96.977 60.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-amexCard, .cls-3-amexCard {\n        fill: #016fd0;\n      }\n\n      .cls-1-amexCard {\n        fill-rule: evenodd;\n      }\n\n      .cls-2-amexCard {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AmexCard",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-1-amexCard",
    d: "M5.3,61.15a4.349,4.349,0,0,1-4.3-4.3V5.3A4.349,4.349,0,0,1,5.3,1H93.681a4.349,4.349,0,0,1,4.3,4.3V56.854a4.349,4.349,0,0,1-4.3,4.3Z",
    transform: "translate(-1.001 -1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-0.001 15.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3082",
    className: "cls-2-amexCard",
    d: "M249.14,1556.018v-15.187h16.13L267,1543.08l1.788-2.249h58.55v14.14a6.775,6.775,0,0,1-3.3,1.047h-32.42l-1.951-2.394v2.394h-6.394v-4.087a5.377,5.377,0,0,1-2.762.571h-2.176v3.516h-9.681l-1.728-2.3-1.755,2.3Z",
    transform: "translate(-230.361 -1520.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3080",
    className: "cls-2-amexCard",
    d: "M55.5,1344.078l3.626-8.454H65.4l2.058,4.736v-4.736h7.8l1.225,3.423,1.188-3.423h34.995v1.721a7.55,7.55,0,0,1,4.863-1.721l11.355.04,2.022,4.674v-4.713h6.524l1.8,2.685v-2.685H145.8v15.187h-6.584l-1.721-2.693v2.693h-9.585l-.964-2.394h-2.577l-.948,2.394h-6.5a6.425,6.425,0,0,1-4.264-1.686v1.686h-9.8l-1.945-2.394v2.394H64.468l-.963-2.394H60.936l-.956,2.394H55.5Z",
    transform: "translate(-55.5 -1335.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    className: "cls-3-amexCard",
    d: "M60.584,1354.93,55.693,1366.3h3.184l.9-2.277h5.246l.9,2.277h3.254l-4.886-11.372H60.584Zm1.81,2.646,1.6,3.979h-3.2Z",
    transform: "translate(-55.674 -1353.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3048",
    className: "cls-3-amexCard",
    d: "M198.223,1366.278v-11.372l4.525.017,2.632,7.332,2.569-7.349h4.489v11.372h-2.843V1357.9l-3.014,8.379h-2.493l-3.022-8.379v8.379Z",
    transform: "translate(-184.382 -1353.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    className: "cls-3-amexCard",
    d: "M364.861,1366.278v-11.372h9.277v2.544h-6.4v1.945h6.255v2.394h-6.255v2.02h6.4v2.469Z",
    transform: "translate(-334.86 -1353.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3052",
    className: "cls-3-amexCard",
    d: "M477.5,1354.93V1366.3h2.843v-4.04h1.2l3.409,4.04h3.474l-3.741-4.189a3.464,3.464,0,0,0,3.119-3.493,3.678,3.678,0,0,0-3.975-3.689Zm2.843,2.544h3.25a1.3,1.3,0,0,1,1.347,1.2,1.285,1.285,0,0,1-1.3,1.2H480.34Z",
    transform: "translate(-436.573 -1353.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    className: "cls-3-amexCard",
    d: "M598.59,1366.278h-2.9v-11.372h2.9Z",
    transform: "translate(-543.301 -1353.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3056",
    className: "cls-3-amexCard",
    d: "M645.391,1366.278h-.626c-3.032,0-4.872-2.388-4.872-5.639,0-3.331,1.82-5.733,5.649-5.733h3.142v2.693h-3.257c-1.554,0-2.653,1.213-2.653,3.068a2.784,2.784,0,0,0,3.067,3.127h.748Z",
    transform: "translate(-583.22 -1353.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3058",
    className: "cls-3-amexCard",
    d: "M714.843,1354.93l-4.891,11.372h3.184l.9-2.277h5.246l.9,2.277h3.255l-4.886-11.372Zm1.81,2.646,1.6,3.979h-3.2Z",
    transform: "translate(-646.485 -1353.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3060",
    className: "cls-3-amexCard",
    d: "M852.433,1366.278v-11.372h3.615l4.615,7.145v-7.145h2.843v11.372h-3.5l-4.732-7.332v7.332Z",
    transform: "translate(-775.149 -1353.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3062",
    className: "cls-3-amexCard",
    d: "M269.2,1571.5v-11.372h9.277v2.544h-6.4v1.945h6.255v2.394h-6.255v2.02h6.4v2.469Z",
    transform: "translate(-248.474 -1538.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3064",
    className: "cls-3-amexCard",
    d: "M737.947,1571.5v-11.372h9.277v2.544h-6.4v1.945h6.225v2.394H740.82v2.02h6.4v2.469Z",
    transform: "translate(-671.765 -1538.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    className: "cls-3-amexCard",
    d: "M367.573,1571.5l4.517-5.616-4.625-5.756h3.582l2.754,3.558,2.763-3.558h3.441l-4.564,5.686,4.525,5.686h-3.581l-2.674-3.5-2.609,3.5Z",
    transform: "translate(-337.211 -1538.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3068",
    className: "cls-3-amexCard",
    d: "M499.869,1560.14v11.372h2.918v-3.591h2.993c2.532,0,4.451-1.343,4.451-3.956a3.743,3.743,0,0,0-4.082-3.825Zm2.918,2.572h3.152a1.284,1.284,0,0,1,1.4,1.31,1.312,1.312,0,0,1-1.412,1.309h-3.142Z",
    transform: "translate(-456.775 -1538.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3072",
    className: "cls-3-amexCard",
    d: "M619.448,1560.12v11.372h2.843v-4.04h1.2l3.409,4.04h3.474l-3.741-4.19a3.463,3.463,0,0,0,3.119-3.493,3.678,3.678,0,0,0-3.974-3.689Zm2.843,2.543h3.25a1.305,1.305,0,0,1,1.347,1.2,1.284,1.284,0,0,1-1.3,1.2h-3.292Z",
    transform: "translate(-564.758 -1538.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3074",
    className: "cls-3-amexCard",
    d: "M843.826,1571.5v-2.469h5.69c.842,0,1.206-.455,1.206-.954,0-.478-.363-.961-1.206-.961h-2.571a3.179,3.179,0,0,1-3.48-3.406c0-1.823,1.14-3.582,4.461-3.582h5.536l-1.2,2.559h-4.788c-.915,0-1.2.48-1.2.939a.992.992,0,0,0,1.047.991h2.693c2.491,0,3.572,1.413,3.572,3.264a3.41,3.41,0,0,1-3.708,3.619Z",
    transform: "translate(-767.05 -1538.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3076",
    className: "cls-3-amexCard",
    d: "M951.422,1571.5v-2.469h5.69c.842,0,1.207-.455,1.207-.954,0-.478-.363-.961-1.207-.961h-2.571a3.179,3.179,0,0,1-3.479-3.406c0-1.823,1.14-3.582,4.461-3.582h5.536l-1.2,2.559h-4.788c-.915,0-1.2.48-1.2.939a.991.991,0,0,0,1.047.991h2.693c2.491,0,3.573,1.413,3.573,3.264a3.41,3.41,0,0,1-3.708,3.619Z",
    transform: "translate(-864.213 -1538.354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexCard);
export default __webpack_public_path__ + "static/media/AmexCard.7b777c730c4c0fea0491207cd8cb16af.svg";
export { ForwardRef as ReactComponent };